import { render, staticRenderFns } from "./Riscossioni.vue?vue&type=template&id=785a5f14&"
import script from "./Riscossioni.vue?vue&type=script&lang=ts&"
export * from "./Riscossioni.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports